import { useMyWorkQuery } from '@platform/state/api';
import type { IMyWork } from './IMyWork';

/**
 * «Моя робота» простору з сервера (GET /me/work, правило прототипу v4: виконавець — я, статус поза DONE, усі модулі): записи за терміном
 * для «Призначені вам» і подань /work, лічильники меню «Моя робота» (призначені мені, термін цього тижня, прострочено).
 */
export function useMyWork(ws: string): IMyWork {
  const { data } = useMyWorkQuery(ws, { skip: !ws });
  return { items: data?.items, counts: data ? { mine: data.mine, week: data.week, overdue: data.overdue } : undefined };
}
